import React, { Component } from "react";
import { MDBRow, MDBCol, MDBContainer, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText } from "mdbreact";
import MetaTags from "react-meta-tags";

export default class Publishinterview extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (<>
            <MetaTags>
                <title>ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
                <meta name="description" content="ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University" />
                <meta property="og:title" content="ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์มหาวิทยาลัยราชภัฏกำแพงเพชร" />
                <meta property="og:image" content="../../public/favicon.ico" />
            </MetaTags>
            <br />
            <MDBContainer fluid >
                <MDBRow>
                    <MDBCol lg="1" md="1" sm="1"></MDBCol>
                    <MDBCol lg="10" md="10" sm="10">
                        <MDBCard>
                            <MDBCardBody>
                                <MDBCardTitle className="text-align">
                                    ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์
                                </MDBCardTitle>
                                <MDBCardText>
                                    <div style={{ fontSize: "16px" }}>
                                        <li className="text-danger">ยังไม่มีประกาศ</li>
                                        {/* ระดับปริญญาตรี ภาคปกติ (จันทร์-ศุกร์)
                                            <li><a style={{ color: "#787878" }} href="https://mua.kpru.ac.th/imagesbg/publishinterview_normal.pdf" target="_blank">ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์เข้าศึกษาต่อภาคปกติ (กำแพงเพชรและแม่สอด) รอบ 1 และโครงการแนะแนวการศึกษาต่อ KPRU ROAD SHOW ประจำปีการศึกษา 2565</a></li>
                                            <li><a style={{ color: "#787878" }} href="https://mua.kpru.ac.th/imagesbg/publishinterview_normal_rob2.pdf" target="_blank">ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์เข้าศึกษาต่อภาคปกติ (กำแพงเพชรและแม่สอด) รอบ 2 และโครงการแนะแนวการศึกษาต่อ KPRU ROAD SHOW ประจำปีการศึกษา 2565</a></li>
                                            <li><a style={{ color: "#787878" }} href="https://mua.kpru.ac.th/imagesbg/publishinterview_normal_nurse.pdf" target="_blank">ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์เข้าศึกษาต่อภาคปกติ หลักสูตรพยาบาลศาสตรบัณฑิต ประจำปีการศึกษา 2565</a></li>
                                            <li><a style={{ color: "#787878" }} href="https://mua.kpru.ac.th/imagesbg/publishinterview_normal_rob3.pdf" target="_blank">ประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ คณะครุศาสตร์ รอบ 3 ประจำปีการศึกษา 2565</a></li>
                                            <br />
                                            ระดับปริญญาตรี ภาคกศ.บป. (เสาร์-อาทิตย์)
                                            <li><a style={{ color: "#787878" }} href="https://mua.kpru.ac.th/imagesbg/publishinterview_special.pdf" target="_blank">ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์ ภาคกศ.บป. (กำแพงเพชรและแม่สอด) รอบ 1 ประจำปีการศึกษา 2565</a></li>
                                            <br /> */}
                                        {/* ระดับประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู
                                            <li><a style={{ color: "#787878" }} href="https://mua.kpru.ac.th/imagesbg/publishinterview_kru.pdf" target="_blank">ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์เข้าศึกษาต่อหลักสูตรประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู ประจำปีการศึกษา 2564</a></li> */}
                                    </div>
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol lg="1" md="1" sm="1"></MDBCol>
                </MDBRow>
            </MDBContainer>
        </>)
    }
}